import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import Collection from "../collection/Collection";
import { cleanDataBackRoot, getRoot } from "../../actions/AssetsRootAction";
import { getShared } from "../../actions/AssetsShareAction";
import { getFavorites } from "../../actions/AssetsFavoritesAction";
import { getLastUploads } from "../../actions/AssetsLastUploadAction";
import { emptyExplore } from "../../actions/AssetsExploreAction";
import { getBreadCrumbsByClient } from "../../actions/ClientAction";
import { getUserMentions } from "../../actions/CommentAction";
import { getPlanServices } from "../../actions/PlanServicesAction";
import { SHOW_ONLY_MY_BUNKERS } from "../../utils";
import { cancelSelect } from "../../actions/MultiselectAction";
import UploadFolderDragzone from "../../components/upload-folder-dragzone/UploadFolderDragzone";
import "../private-site/bootstrap.min.css";
import "../private-site/flickity.css";
import "../private-site/privateSite.css";
import RenameModal from "../multi-selector-header-options/rename-modal/RenameModal";
import TagProtocolModal from "../multi-selector-header-options/tag-protocol-modal/TagProtocolModal";
import MoveModal from "../multi-selector-header-options/move-modal/MoveModal";
import DeleteModal from "../multi-selector-header-options/delete-modal/DeleteModal";
import ShareModal from "../multi-selector-header-options/share-modal/ShareModal";
import { individualClear } from "../../actions/IndividualSelectAction";
import GroupModal from "../multi-selector-header-options/group-modal/GroupModal";
import RenameFileModal from "../multi-selector-header-options/rename-file-modal/RenameFileModal";
import { getClientDataById } from "../../actions/ClientAction";
import HomeTourModal from "../explore/explore-tour/HomeTourModal";
import {
  getTourDashboard,
  getTourMenu,
  getTourUsers,
  getTourGroups,
  getTourExplore
} from "../../actions/TourAction";
import DownloadModal from "../multi-selector-header-options/download-modal/DownloadModal";
import { setSelectedFolderExplore } from "../../actions/AppAction";
import { isEnterpriseUser } from "../../utils/plan-utils";
export class Home extends Component {
  componentDidMount() {
    const { workclient, root, intl, user, clientselect } = this.props;

    if (workclient && root) {
      this.props.emptyExplore();
      this.props.cleanDataBackRoot();
      this.props.getTourExplore(user._id);
      this.props.getRoot(workclient, root, true, [], 1, 40);
      this.props.getLastUploads(workclient, root);
      // this.props.getBreadCrumbsByClient(workclient);
      this.props.getShared(workclient, root);
      this.props.getFavorites(workclient, root);
      this.props.getUserMentions(workclient, intl);
      // Remover servicio => 
      if (clientselect && !isEnterpriseUser(clientselect)) {
        this.props.getPlanServices();
      }
      this.props.getClientDataById(workclient);
      this.props.getTourDashboard(user._id);
      this.props.getTourMenu(user._id);
      this.props.getTourUsers(user._id);
      this.props.getTourGroups(user._id);
    } else {
      this.props.history.push("/");
    }
    this.props.setSelectedFolderExplore(null);
  }

  componentWillUnmount() {
    this.props.cancelSelect();
  }
  componentDidUpdate() {
    const {
      workclient,
      root,
      showScrolling,
      dataRoot,
      pageScrolling
    } = this.props;
    if (showScrolling && root) {
      this.props.getRoot(workclient, root, true, dataRoot, pageScrolling, 40);
    }
  }
  render() {
    const {
      intl,
      workclient,
      selectedFile,
      action,
      tourExplore,
      user
    } = this.props;
    return (
      <React.Fragment>
        <UploadFolderDragzone />
        <Collection
          title={intl.formatMessage({ id: "my_bunkers" })}
          keyCollection="assetsRoot"
        />
        {!SHOW_ONLY_MY_BUNKERS.includes(workclient) && (
          <Collection
            title={intl.formatMessage({ id: "last_uploads" })}
            keyCollection="assetsLastUploads"
          />
        )}
        {!SHOW_ONLY_MY_BUNKERS.includes(workclient) && (
          <Collection
            title={intl.formatMessage({ id: "shared" })}
            keyCollection="assetsShared"
          />
        )}
        {!SHOW_ONLY_MY_BUNKERS.includes(workclient) && (
          <Collection
            title={intl.formatMessage({ id: "favorites" })}
            keyCollection="assetsFavorites"
          />
        )}
        {selectedFile && action === "tag_protocol" && (
          <TagProtocolModal
            showModal={action === "tag_protocol"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "rename" && (
          <RenameModal
            showModal={action === "rename"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "move" && (
          <MoveModal
            showModal={action === "move"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "group" && (
          <GroupModal
            showModal={action === "group"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}

        {selectedFile && action === "delete" && (
          <DeleteModal
            showModal={action === "delete"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}

        {selectedFile && action === "share" && (
          <ShareModal
            showModal={action === "share"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "download" && (
          <DownloadModal
            showModal={action === "download"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "renameFile" && (
          <RenameFileModal
            showModal={action === "renameFile"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {user &&
          !user.forcePasswordChange &&
          !user.modalNews &&
          tourExplore.length !== 0 && <HomeTourModal />}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    root: state.client.root,
    workclient: state.client.workclient,
    selectedFile: state.individualSelect.selectedFile,
    action: state.individualSelect.action,
    user: state.authUser.user,
    tourExplore: state.tours.tourExplore,
    showScrolling: state.assetsRoot.showScrolling,
    dataRoot: state.assetsRoot.data,
    pageScrolling: state.assetsRoot.pageScrolling,
    clientselect: state.client.data
  };
};

const mapDispatchToProps = {
  getRoot,
  getShared,
  getFavorites,
  getLastUploads,
  getBreadCrumbsByClient,
  emptyExplore,
  getUserMentions,
  getPlanServices,
  cancelSelect,
  individualClear,
  getClientDataById,
  getTourDashboard,
  getTourMenu,
  getTourUsers,
  getTourGroups,
  getTourExplore,
  setSelectedFolderExplore,
  cleanDataBackRoot,
  isEnterpriseUser
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Home))
);
